import { render, staticRenderFns } from "./EmergencyNumberSettings.vue?vue&type=template&id=75ab60a1&scoped=true"
import script from "./EmergencyNumberSettings.vue?vue&type=script&lang=js"
export * from "./EmergencyNumberSettings.vue?vue&type=script&lang=js"
import style0 from "@/assets/styles/emergency-numbers.css?vue&type=style&index=0&id=75ab60a1&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../../4rahgit/GPS-Tracking-Client-Panel/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75ab60a1",
  null
  
)

export default component.exports